<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstPerson"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPerson"
		dataKey="PersonID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StaffID-->
				<th>
					<p-columnFilter type="text" field="StaffID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StaffTitle-->
				<th>
					<p-columnFilter type="text" field="StaffTitle" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--VisiteeEnabledDesc-->
				<th class="SmallCol">
					<p-columnFilter field="VisiteeEnabledDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterVisiteeEnabledDesc
								[ngModel]="value"
								[options]="lstVisiteeEnabledDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--NotifyByEmailDesc-->
				<th class="SmallCol">
					<p-columnFilter field="NotifyByEmailDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterNotifyByEmailDesc
								[ngModel]="value"
								[options]="lstNotifyByEmailDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Email-->
				<th>
					<p-columnFilter type="text" field="Email" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="StaffID">Staff ID<p-sortIcon field="StaffID"></p-sortIcon></th>
				<th pSortableColumn="StaffTitle">Title<p-sortIcon field="StaffTitle"></p-sortIcon></th>
				<th pSortableColumn="VisiteeEnabledDesc" class="SmallCol">Enabled<p-sortIcon field="VisiteeEnabledDesc"></p-sortIcon></th>
				<th pSortableColumn="NotifyByEmailDesc" class="SmallCol">Receive Emails<p-sortIcon field="NotifyByEmailDesc"></p-sortIcon></th>
				<th pSortableColumn="Email">Email<p-sortIcon field="Email"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Person>
			<tr [pSelectableRow]="Person">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person.FirstName }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person.LastName }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person.StaffID }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person.StaffTitle }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" class="SmallCol">
					<input type="checkbox" class="CHK" [(ngModel)]="Person.VisiteeEnabled" (ngModelChange)="onPersonVisiteeEnabledChange(Person, $event)" />
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" class="SmallCol">
					<label *ngIf="Person.VisiteeEnabled == false">{{ Person.NotifyByEmailDesc }}</label>
					<input
						*ngIf="Person.VisiteeEnabled == true"
						class="CHK"
						type="checkbox"
						[(ngModel)]="Person.NotifyByEmail"
						(ngModelChange)="onPersonNotifyByEmailChange(Person, $event)"
					/>
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					<label *ngIf="Person.VisiteeEnabled == false">{{ Person.Email }}</label>
					<input *ngIf="Person.VisiteeEnabled == true" type="text" class="form-control" [(ngModel)]="Person.Email" />
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
